export default __webpack_public_path__ + "static/media/product-image-thumbnail.9510b4f0.svg";